"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePreviousValue = void 0;
const react_1 = require("react");
/**
 * Hook that returns the last distinct value.
 * returns null until the original value changes
 */
function usePreviousValue(value) {
    const [current, setCurrent] = (0, react_1.useState)(null);
    const [previous, setPrevious] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (value !== current) {
            setPrevious(current);
            setCurrent(value);
        }
    }, [value, current]);
    return previous;
}
exports.usePreviousValue = usePreviousValue;
